import React, { useState } from 'react';
import { Archive } from 'lucide-react';
import { Input } from '../ui/input';
import { downloadBlob, PRODUITS_FILTRE } from './api';

export const ArchiveAnnuelle = ({ headers }) => {
  const [annee, setAnnee] = useState(String(new Date().getFullYear()));
  const [produit, setProduit] = useState('');
  const [busy, setBusy] = useState(false);
  const telecharger = async () => {
    setBusy(true);
    try { await downloadBlob(`/comptabilite/archive.zip?annee=${annee}&produit=${produit}`, headers, `archive_comptable_${produit ? `${produit}_` : ''}${annee}.zip`); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2" data-testid="archive-annuelle">
      <Archive className="h-4 w-4 text-[#0a3d62]" />
      <span className="text-sm font-medium text-slate-700">Archive annuelle</span>
      <Input type="number" min="2024" max="2100" value={annee} onChange={(e) => setAnnee(e.target.value)} className="h-8 w-24 text-sm" data-testid="archive-annee-input" />
      <select value={produit} onChange={(e) => setProduit(e.target.value)} data-testid="archive-produit-select"
        className="h-8 rounded-md border border-slate-300 bg-white px-2 text-xs text-slate-700">
        {PRODUITS_FILTRE.map(([k, l]) => <option key={k || 'tous'} value={k}>{l}</option>)}
      </select>
      <button type="button" onClick={telecharger} disabled={busy || annee.length !== 4} data-testid="archive-download-btn"
        className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded-lg bg-[#0a3d62] text-white hover:bg-[#0c4a75] disabled:opacity-50">
        <Archive className={`h-3.5 w-3.5 ${busy ? 'animate-pulse' : ''}`} /> {busy ? 'Préparation…' : 'Télécharger le ZIP'}
      </button>
      <span className="text-[11px] text-slate-500">Par mois : Excel, reçus, attestations et justificatifs (sans notes de relance) + grand livre CSV annuel.</span>
    </div>
  );
};
